exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cw-bg[data-v-0c4a3fb9] {\n  background: linear-gradient(45deg, var(--cw-700), var(--cw-alt));\n}\n", ""]);

// exports
